// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchEventsFailure, FetchEventsRequestAction, fetchEventsSuccess } from './actions';
import { FETCH_EVENTS_REQUEST } from './constants';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';
import { sendError } from '../../errorHandler';
import { getErrorSetup } from '../../../../helpers/getErrorSetup';

export function* newsSaga(action: FetchEventsRequestAction) {
    try {
        if(!action.payload.symbol) return;
        const data = yield call(() => api.get(`${appUrls.stockURL}/company/${action.payload.symbol}/events`));

        if (data) {
            yield put(fetchEventsSuccess(data.data));
        }
    } catch (error) {
        yield put(fetchEventsFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootStockEventsSaga(): Generator {
    yield takeLatest(FETCH_EVENTS_REQUEST, newsSaga);
}
